import React, { memo } from 'react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';

type Tone = 'neutral' | 'primary' | 'success' | 'info' | 'error' | 'alert';

/** Small pill counter for tabs; `alert` is a solid error badge that draws attention. */
const CountBadge: React.FC<{ count: number; tone?: Tone }> = ({ count, tone = 'neutral' }) => (
  <Box
    component="span"
    sx={(theme) => {
      const solid = tone === 'alert';
      const paletteColor = tone === 'neutral' ? null : theme.palette[solid ? 'error' : tone];
      return {
        minWidth: 22,
        height: 20,
        px: 0.75,
        boxSizing: 'border-box',
        borderRadius: 10,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 600,
        fontVariantNumeric: 'tabular-nums',
        bgcolor: solid ? paletteColor!.main : paletteColor ? alpha(paletteColor.main, 0.16) : theme.palette.action.selected,
        color: solid ? paletteColor!.contrastText : paletteColor ? paletteColor.main : theme.palette.text.secondary,
      };
    }}
  >
    {count}
  </Box>
);

export default memo(CountBadge);
